var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 11.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 13.0018C22.8438 12.8456 22.6319 12.7578 22.4109 12.7578C22.19 12.7578 21.978 12.8456 21.8218 13.0018L18.0001 16.8235L14.1784 13.0018C14.0222 12.8456 13.8102 12.7578 13.5893 12.7578C13.3683 12.7578 13.1564 12.8456 13.0001 13.0018C12.8439 13.1581 12.7561 13.37 12.7561 13.591C12.7561 13.8119 12.8439 14.0239 13.0001 14.1801L16.8218 18.0018L13.0001 21.8235C12.8439 21.9797 12.7561 22.1917 12.7561 22.4126C12.7561 22.6336 12.8439 22.8455 13.0001 23.0018C13.1564 23.158 13.3683 23.2458 13.5893 23.2458C13.8102 23.2458 14.0222 23.158 14.1784 23.0018L18.0001 19.1801L21.8218 23.0018C21.978 23.158 22.19 23.2458 22.4109 23.2458C22.6319 23.2458 22.8438 23.158 23.0001 23.0018C23.1563 22.8455 23.2441 22.6336 23.2441 22.4126C23.2441 22.1917 23.1563 21.9797 23.0001 21.8235L19.1784 18.0018L23.0001 14.1801C23.1563 14.0239 23.2441 13.8119 23.2441 13.591C23.2441 13.37 23.1563 13.1581 23.0001 13.0018Z",
    fill: "#1D2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderCross);
export default __webpack_public_path__ + "static/media/border-cross.a58f99cbac6d42449f377765cfaa82b9.svg";
export { ForwardRef as ReactComponent };